export enum UserRole {
  admin = "admin",
  bigboard = "bigBoard",
}
